export default {"src":"/_next/static/media/amusement_parks.5ba9afb3.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};